import { FC, Fragment, PropsWithChildren } from 'react';
import { observer } from 'mobx-react';
import { Snackbar } from '@servicetitan/design-system';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Notifications as DefaultNotifications } from '@servicetitan/notifications';
import { SNACKBAR_DURATION } from '../../utils/ux';
import { NotificationsStore } from '../../stores/notifications.store';

const SnackbarNotifications: FC<PropsWithChildren> = provide({ singletons: [NotificationsStore] })(
    observer(({ children }) => {
        const [{ snackbarNotification }] = useDependencies(NotificationsStore);

        return (
            <Fragment>
                {children}
                {!!snackbarNotification && (
                    <Snackbar
                        className="m-l-4 m-b-4"
                        duration={SNACKBAR_DURATION}
                        {...snackbarNotification}
                    />
                )}
            </Fragment>
        );
    }),
);

export const Notifications: FC<PropsWithChildren> = ({ children }) => {
    return (
        <DefaultNotifications>
            <SnackbarNotifications>{children}</SnackbarNotifications>
        </DefaultNotifications>
    );
};
